import { Action } from "./action";
import { State } from "./state";

export const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case "aggregate":
			return {
				...state,
				aggregateJob: action.payload,
			};
		case "file":
			return {
				...state,
				file: action.payload,
				fileInvalid: false,
			};
		case "fileInvalid":
			return {
				...state,
				fileInvalid: action.payload,
			};
		case "job":
			return {
				...state,
				job: action.payload,
			};
		case "message_info":
			return {
				...state,
				info: action.payload,
				progressState: "done",
			};
		case "progress_state":
			return {
				...state,
				progressState: action.payload,
			};
	}
};
